(function(){
  var Q=[
    {q:"Votre type de peau ?",a:["Sèche","Mixte","Grasse","Sensible"],k:"type"},
    {q:"Votre préoccupation n°1 ?",a:["Teint terne, manque d'éclat","Rides et perte de fermeté","Imperfections et pores dilatés","Peau déshydratée, tiraille"],k:"concern"},
    {q:"Votre objectif ?",a:["Prévenir","Corriger","Entretenir"],k:"goal"}
  ];
  var REC={
    0:{h:"serum-eclat-vitamine-c",d:"Pour raviver l'éclat et unifier le teint, dès 28 jours."},
    1:{h:"serum-nuit-retinol",d:"Pour lisser les rides et raffermir la peau, la nuit."},
    2:{h:"serum-anti-pores-niacinamide",d:"Pour resserrer les pores et affiner le grain de peau."},
    3:{h:"serum-hydratation-acide-hyaluronique",d:"Pour repulper et hydrater la peau en profondeur."}
  };
  var step=0, ans={}, stage=document.getElementById('gqStage'), bar=document.getElementById('gqBar');
  function euros(c){return (c/100).toLocaleString('fr-FR',{minimumFractionDigits:2})+' €';}
  function showResult(){
    bar.style.width="100%";
    var r=REC[ans.concern!=null?ans.concern:0];
    stage.innerHTML='<div class="gq-res"><p class="gq-res-k">VOTRE SOIN IDÉAL</p><div class="gq-card" id="gqCard"><div class="gq-load">Analyse de votre peau…</div></div><form class="gq-email" id="gqEmail"><input type="email" required placeholder="Votre e-mail pour recevoir votre routine"><button type="submit">Recevoir ma routine</button></form><p class="gq-ok" id="gqOk" hidden>Merci, votre routine personnalisée arrive par e-mail.</p><button class="gq-restart" id="gqRestart">Recommencer le diagnostic</button></div>';
    fetch('/products/'+r.h+'.js').then(function(x){return x.json();}).then(function(p){
      var img=p.featured_image||(p.images&&p.images[0])||'';
      if(img&&img.indexOf('?')<0){img=img+'?width=320';}
      document.getElementById('gqCard').innerHTML=
        '<a class="gq-card-link" href="/products/'+r.h+'"><img src="'+img+'" alt="'+p.title+'" loading="lazy"><div class="gq-card-info"><div class="gq-card-t">'+p.title+'</div><div class="gq-card-d">'+r.d+'</div><div class="gq-card-p">'+euros(p.price)+'</div></div></a>'+
        '<button class="gq-cta" id="gqAdd" data-id="'+p.variants[0].id+'">Ajouter au panier</button>';
      document.getElementById('gqAdd').onclick=function(){
        var b=this; b.textContent='Ajout…';
        fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:b.getAttribute('data-id'),quantity:1})}).then(function(){window.location.href='/cart';}).catch(function(){b.textContent='Ajouter au panier';});
      };
    }).catch(function(){
      document.getElementById('gqCard').innerHTML='<a class="gq-cta" href="/products/'+r.h+'">Voir mon soin</a>';
    });
    document.getElementById('gqEmail').onsubmit=function(e){e.preventDefault();this.style.display='none';document.getElementById('gqOk').hidden=false;};
    document.getElementById('gqRestart').onclick=function(){step=0;ans={};render();};
  }
  function render(){
    bar.style.width=(step/Q.length*100)+"%";
    if(step<Q.length){
      var it=Q[step], h='<div class="gq-q">'+it.q+'</div><div class="gq-opts">';
      for(var i=0;i<it.a.length;i++){h+='<button class="gq-opt" data-i="'+i+'">'+it.a[i]+'</button>';}
      h+='</div>'; stage.innerHTML=h;
      var bs=stage.querySelectorAll('.gq-opt');
      for(var j=0;j<bs.length;j++){(function(b){b.onclick=function(){ans[it.k]=+b.getAttribute('data-i');step++;render();};})(bs[j]);}
    }else{showResult();}
  }
  render();
})();
